import React, { useEffect } from 'react'
import HolidayScheduleContainer from '../containers/HolidaySchedule'
import Nav from '../components/nav/Nav';

const HolidaySchedule: React.FC= () => {



  useEffect(() => {
    document.title = 'Elite Community CU | Holiday Schedule';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "Elite Community Credit Union secure and reliable banking for all your needs. Get competitive rates, manage your finances on the go, and experience exceptional customer service. Open an account today";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <Nav />
      <HolidayScheduleContainer />
    </div>
  )
}

export default HolidaySchedule